import { isNative } from '@/core/platform/runtime'
import type { CameraProvider } from './cameraProvider'
import { webCameraProvider } from './webCameraProvider'

let current: CameraProvider = webCameraProvider

export function cameraProvider(): CameraProvider {
  return current
}

export async function initCameraProvider(): Promise<void> {
  if (!isNative()) return
  try {
    const mod = await import('./nativeCameraProvider')
    current = mod.nativeCameraProvider
    console.info('[camera] NativeCameraProvider ativo (Capacitor native)')
  } catch (err) {
    console.warn('[camera] falha ao carregar NativeCameraProvider, fallback web:', err)
  }
}

export type { CameraProvider, CapturedPhoto, CameraStreamHandle } from './cameraProvider'
